import React from 'react';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import Category from "../categorySection/Category"
export default function DialogEditCategorySection ({ editType, open, handleClose, fromEditAction }) {
    return (
        <div>
            <Dialog open={open} aria-labelledby="form-dialog-title" maxWidth="md" fullWidth>
                <DialogTitle id="form-dialog-title">Category section settings</DialogTitle>
                <DialogContent>
                    <Category editType={editType} handleClose={handleClose} fromEditAction={fromEditAction} />
                </DialogContent>
            </Dialog>
        </div >
    );
}